<template>
  <div v-if="homeData">
    <MainCategoryBox />
    <Targets v-if="homeData" />
    <IndustrialPark />
    <!-- <Customerscomments/> -->
    <Partners />
  </div>
  <loader v-else />
</template>

<script>
import loader from "../components/loader.vue"
import MainCategoryBox from "../components/main/MainCategoryBox.vue";
import Targets from "../components/main/Targets.vue";
import IndustrialPark from "../components/main/IndustrialPark.vue";
// import Customerscomments from "../components/main/Customerscomments.vue";
import Partners from "../components/main/Partners.vue";
export default {
  data() {
    return {};
  },
  computed: {
    homeData() {
      return this.$store.getters.getHomeData;
    }
  },
  components: { MainCategoryBox, Targets, IndustrialPark, Partners,loader },
  mounted() {
     this.$axios.defaults.headers.common["Accept-Language"] = this.$cookie.get(
                "language"
            ) ?
            this.$cookie.get("language") :
            "fa";
    if (this.homeData == null) {
     this.$store.dispatch("getHomeDataFromServer")
    }
  },
  metaInfo() {
        return { 
            title: "صفحه اصلی",
            meta: [
                { name: 'description', content:  'صفحه اصلی'},
                { property: 'og:title', content: "صفحه اصلی"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>

<style scoped></style>
